import React, { Component } from "react";
import {notification } from "antd";
import "./ViewerPage.css";
import "antd/dist/antd.css";
import { ExamImagesApiService } from "../../api/ExamImagesApi.service";
import { ExamApiService } from "../../api/ExamApi.service";
import { OrganizationsService } from "../../services/organizationsService";
import { withRouter } from 'react-router-dom';
import { compose } from "redux";
import  {connect} from "react-redux";
import moment from 'moment';
import ViewerBase from "./components/ViewerBase/ViewerBase";

class ViewerPage extends Component {
	constructor() {
		super();
		this.onExamChanged = this.onExamChanged.bind(this);
	}

	saveExams = (exam) => {
		ExamApiService.setExaminationStatus(exam.examinationId, {
			left: exam.leftEyeDiagnosis,
			right: exam.rightEyeDiagnosis,
			doctorNote: exam.doctorNote,
			doctorAdvice: exam.doctorAdvice,
			iccValue: exam.iccValue
		})
			.then(
			() => {
				this.props.history.push(`/dashboard/exams`);
			},
			() => {
				notification.open({
					message: 'Error',
					description:
						'Failed to save diagnosis',
				});
			}
		);
	}

	loadExamData(examId, setExamHistory, onImageLoaded, onImageLoadingFailed, setImages) {
		return Promise.all([
			ExamImagesApiService.getImages(examId),
			ExamApiService.getExaminationsAnalysisResult(examId),
			ExamApiService.getExamination(examId)
		])
			.then(
				async ([images, [leftResults, rightResults], exam]) => {
					ExamApiService.getExaminations(exam.patientNumber)
                        .then(
                            data => {
                                data.sort((a, b) => {
                                    if (moment(a.examinationDate) > moment(b.examinationDate)) {
                                        return -1;
                                    }
                                    if (moment(a.examinationDate) < moment(b.examinationDate)) {
                                        return 1;
                                    }

                                    return 0;
                                });

                                setExamHistory(data);
                            }
                        );

                    const organization = await OrganizationsService.getById(exam.creatorDepartment.organizationId);
                    const highThreshold = organization.highThreshold;

                    let hasRetinopathy = {
                        left: false,
                        right: false
                    };

                    let hasAreaEqualZero = {
                        left: true,
                        right: true
                    };

                    let hasGroupRetinopathyByHighThreshold = {
                        left: false,
                        right: false
                    };

					images.forEach(image => {

						image.domImage = new window.Image();

						ExamImagesApiService.getImage(image.id).then((imageBlob) => {
							image.domImage.src = URL.createObjectURL(imageBlob);
							image.imageBlob = imageBlob;
						}).catch(() => {
							onImageLoadingFailed(image);
						})

						image.domImage.onload = () => {
							onImageLoaded();
						}
						
						image.domImage.onerror = (e) => {
							if (onImageLoadingFailed)
								onImageLoadingFailed(image);
						}

						let examResults = {
							left: leftResults,
							right: rightResults
						};

						let fileResult = examResults[image.eyeSide][image.fileName];

                        let groupResult = examResults[image.eyeSide]["request_result"];

                        if (groupResult) {
                            image.hasGroupRetinopathy = !!groupResult.desease_prediction;
                            hasGroupRetinopathyByHighThreshold[image.eyeSide] = groupResult.desease_proba >= highThreshold;
                        }

						if (fileResult && fileResult.read_status !== "ERROR") {
							image.analysis = fileResult;

							image.hasRetinopathy = !!fileResult.desease_prediction;
							image.hasRetinopathyByHighThreshold = fileResult.desease_proba >= highThreshold;

							image.hasAmd = fileResult.has_signs_of_amd;
							image.hasGlaucoma = fileResult.has_signs_of_glaucoma;
							image.gradable = fileResult.gradable;
							image.deseaseProba = (fileResult.desease_proba * 1000).toString().substring(0, 3);

                            hasRetinopathy[image.eyeSide] = hasRetinopathy[image.eyeSide] || image.hasRetinopathy;

                            const isAreaEqualZero = fileResult.MA_area === 0 && fileResult.HE_area === 0;
                            if (image.gradable) {
                                hasAreaEqualZero[image.eyeSide] = hasAreaEqualZero[image.eyeSide] && isAreaEqualZero;
                            }
						}
					});

                    images.forEach(image => {
                        image.someImageHasRetinopathy = hasRetinopathy[image.eyeSide];
                        image.hasEyeSideAreaEqualZero = hasAreaEqualZero[image.eyeSide];

                        if(image.hasEyeSideAreaEqualZero) {
                            image.hasRetinopathy = image.hasRetinopathyByHighThreshold;
                            image.hasGroupRetinopathy = hasGroupRetinopathyByHighThreshold[image.eyeSide];
                            console.log("Set group retinopathy by high threshold: " + image.eyeSide + ' ' + image.hasGroupRetinopathy);
                        }
                    });

					setImages(images, exam);
				}
		);
	}	

	onExamChanged(value, selectedImageEyeSide) {
        this.props.history.push(`/dashboard/viewer/${value}/${selectedImageEyeSide}`);
    }


	render() {
		return (
			<ViewerBase onExamChanged={this.onExamChanged}
			onSaveExam={this.saveExams} onLoadExamData={this.loadExamData}></ViewerBase>
		)
	}
}

export default connect()(compose(withRouter)(ViewerPage));
